<template>
<v-card :dark='dark' :loading='req.loading' v-bind='attrs' >
  <v-img
      height="160px"
      :src="backgroundPicture" >
  </v-img>
  <v-btn v-if='cta' absolute top right small
    :to='cta.link'
    :color='cta.color' >
    {{cta.text}}
    <v-icon v-if='cta.icon' class='ml-1' >{{icon}}</v-icon>
  </v-btn>
  <v-divider />
  <v-card-title
    style='margin-top:-150px;'
    class='subtitle-1 overline justify-center' >
    <v-avatar size='200' class='mb-3 elevation-10' color='white' >
      <v-img v-if='profilePicture' :src='profilePicture' height='200' width=200 />
      <span v-else style='font-size:70px' class='black--text' v-text='initials'></span>
    </v-avatar>
  </v-card-title>
  <v-card-text>
    <center>
      <h2>{{fullname}}</h2>
      <small v-if='profile.registration_number' v-text='profile.registration_number' /><br/>
      <v-chip small v-if='profession && profession.name' color='success' class='mt-3' >
        {{profession.name}}
      </v-chip>
    </center>
    <p class='mt-3 caption justify' v-if='profile.description' v-text='profile.description' />
    <v-row >
      <v-col cols=12 xl=6 v-if='me.email' >
        <v-icon small >mdi-email</v-icon> {{me.email}}
      </v-col>
      <v-col cols=12 xl=6 v-if='me.phone_number' >
        <v-icon small >mdi-phone</v-icon> {{me.phone_number}}
      </v-col>
    </v-row>
  </v-card-text>
  <v-card-text class='text-center' >

      <v-icon large
        v-for='icon in social'
        :key='icon.id'
        @mouseover="setFocus(icon)"
        :color="getFocusColor(icon.link)"
        class='mx-2' >
          mdi-{{icon.id}}
      </v-icon><br/>
      <v-chip small outlined
        color='primary' class='mt-3'
        v-if='socialfocus' >
        <v-icon left >mdi-{{socialfocus.id}}</v-icon>
        {{socialfocus.link}}
      </v-chip>

  </v-card-text>
  <v-divider />
  <v-card-actions v-if='withEdit' >
    <v-spacer />
    <v-btn text to='/settings/me/profile' >Edit</v-btn>
  </v-card-actions>
  <!-- <pre v-text='me' /> -->
</v-card>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'PractitionerCard',
  props: {
    value: { type: Object, required: false },
    cta: { type: Object, required: false },
    id: { required: false },
    flat: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },
    withEdit: { type: Boolean, default: true },
    attrs: { type: Object, default: () => {} },
  },
  data () {
    return {
      socialfocus: null,
      req: {
        resource: 'ag.v2.practitioner.me'
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['meId']),
    me () {
      if (this.value) { return this.value }
      return this.getObjectPath(this.req, 'result', {})
    },
    fullname () {
      let fname = this.me.first_name
      if (this.me.last_name) {
        fname = fname + ' ' + this.me.last_name
      }
      return fname
    },
    initials () {
      let first = ''
      let last = ''
      if (this.me && this.me.first_name) {
        first = this.me.first_name.substr(0, 1)
      }
      if (this.me && this.me.last_name) {
        last = this.me.last_name.substr(0, 1)
      }
      return `${first}${last}`.toUpperCase()
    },
    profile () {
      return this.getObjectPath(this.me, 'profile', {})
    },
    profession () {
      return this.getObjectPath(this.me, 'profile.profession', {})
    },
    backgroundPicture () {
      let custom = this.getObjectPath(this.profile, 'background_picture')
      if (!custom) {
        return 'https://images.unsplash.com/photo-1530543787849-128d94430c6b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
      }
      return custom
    },
    profilePicture () {
      return this.getObjectPath(this.profile, 'profile_picture')
    },
    social () {
      let links = []
      if (this.profile.facebook) {
        links.push({ id: 'facebook', link: this.profile.facebook })
      }
      if (this.profile.linkedin) {
        links.push({ id: 'linkedin', link: this.profile.linkedin })
      }
      if (this.profile.instagram) {
        links.push({ id: 'instagram', link: this.profile.instagram })
      }
      if (this.profile.twitter) {
        links.push({ id: 'twitter', link: this.profile.twitter })
      }
      return links
    }
  },
  methods: {
    getMe () {
      this.req.resourceId = this.id
      this.$request('get', this.req)
    },
    setFocus (f) {
      this.socialfocus = f
    },
    getFocusColor (f) {
      if (this.socialfocus === f) { return 'primary' }
    }
  },
  watch: {
    social: {
      immediate: true,
      handler () {
        if (this.social && this.social.length > 0) {
          this.socialfocus = this.social[0]
        }
      }
    },
    id: {
      immediate: true,
      handler () {
        if (this.meId) { this.getMe() }
      }
    }
  }
}
</script>
